import React, { useEffect, useRef } from 'react';

// A short confirmation shown at the top of the page. Polaris's own Toast sits at
// the bottom centre, where Shopify's Sidekick bar now covers it. Same props as
// Polaris's (content, onDismiss), so pages swap it in without other changes.
const SHOW_MS = 5000;

function Toast({ content, onDismiss }) {
  // Pages pass a fresh onDismiss each render; the timer restarts only for a new message.
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;
  useEffect(() => {
    const timer = setTimeout(() => dismiss.current(), SHOW_MS);
    return () => clearTimeout(timer);
  }, [content]);

  return (
    <div className="og-toast" role="status" aria-live="polite">
      <span>{content}</span>
      <button type="button" className="og-toast__close" onClick={onDismiss} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}

export default Toast;
